module.exports = "<div class=\"modal-header\">\n    <h2> Attivazione senza indirizzo </h2>\n</div>\n<p> </p>\n<p>\n    Stai cercando di attivare il vas senza prima aver inserito l'indirizzo di consegna!\n    Per favore, inserisci l'indirizzo di consegna prima di proseguire all'attivazione del vas\n</p>\n<footer>\n    <button class=\"button\" ng-click=\"okFunc()\"> {{ \"services.activations.buttons.activate.modal.button\" | translate}} </button>\n</footer>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/services/SuggestToInsertAddressModal.html
 ** module id = 532
 ** module chunks = 0
 **/